
import { useState } from 'react';
import AdminLayout from '../../../components/feature/AdminLayout';

export default function AdminStudents() {
  const [students] = useState([
    {
      id: 'STU-001',
      name: '김학습',
      email: 'student1@email.com',
      phone: '010-1234-5678',
      registeredAt: '2024-01-15',
      certificateCount: 3,
      lastActivity: '2024-01-20',
      status: 'active'
    },
    {
      id: 'STU-002',
      name: '이수료',
      email: 'student2@email.com',
      phone: '010-2345-6789',
      registeredAt: '2024-01-10',
      certificateCount: 2,
      lastActivity: '2024-01-19',
      status: 'active'
    },
    {
      id: 'STU-003',
      name: '박완료',
      email: 'student3@email.com',
      phone: '010-3456-7890',
      registeredAt: '2024-01-08',
      certificateCount: 1,
      lastActivity: '2024-01-18',
      status: 'inactive'
    },
    {
      id: 'STU-004',
      name: '최교육',
      email: 'student4@email.com',
      phone: '010-4567-8901',
      registeredAt: '2024-01-05',
      certificateCount: 4,
      lastActivity: '2024-01-17',
      status: 'active'
    },
    {
      id: 'STU-005',
      name: '정학습',
      email: 'student5@email.com',
      phone: '010-5678-9012',
      registeredAt: '2024-01-03',
      certificateCount: 1,
      lastActivity: '2024-01-16',
      status: 'suspended'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedStudents, setSelectedStudents] = useState<string[]>([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newStudent, setNewStudent] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const filteredStudents = students.filter(student => {
    const matchesSearch = student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         student.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         student.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || student.status === statusFilter;
    
    return matchesSearch && matchesStatus;
  });

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedStudents(filteredStudents.map(student => student.id));
    } else {
      setSelectedStudents([]);
    }
  };

  const handleSelectStudent = (studentId: string, checked: boolean) => {
    if (checked) {
      setSelectedStudents([...selectedStudents, studentId]);
    } else {
      setSelectedStudents(selectedStudents.filter(id => id !== studentId));
    }
  };

  const handleBulkAction = (action: string) => {
    if (selectedStudents.length === 0) {
      alert('선택된 학습자가 없습니다.');
      return;
    }
    
    switch (action) {
      case 'activate':
        alert(`선택된 ${selectedStudents.length}명의 학습자를 활성화합니다.`);
        break;
      case 'suspend':
        alert(`선택된 ${selectedStudents.length}명의 학습자를 일시정지합니다.`);
        break;
      case 'delete':
        if (confirm(`선택된 ${selectedStudents.length}명의 학습자를 삭제하시겠습니까?`)) {
          alert('학습자가 삭제되었습니다.');
          setSelectedStudents([]);
        }
        break;
    }
  };

  const handleViewDetail = (student: any) => {
    setSelectedStudent(student);
    setShowDetailModal(true);
  };

  const handleAddStudent = () => {
    if (!newStudent.name || !newStudent.email) {
      alert('이름과 이메일을 입력해주세요.');
      return;
    }

    alert(`새 학습자 "${newStudent.name}"이 추가되었습니다.`);
    setShowAddModal(false);
    setNewStudent({ name: '', email: '', phone: '' });
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'inactive':
        return 'bg-gray-100 text-gray-800';
      case 'suspended':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'active':
        return '활성';
      case 'inactive':
        return '비활성';
      case 'suspended':
        return '정지';
      default:
        return '알 수 없음';
    }
  };

  return (
    <AdminLayout>
      <div className="p-6">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">학습자 관리</h1>
            <p className="text-sm text-gray-500">등록된 학습자 정보를 조회하고 관리하세요</p>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line mr-2"></i>
            학습자 추가
          </button>
        </div>

        {/* 필터 및 검색 */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">검색</label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="이름, 이메일, 학습자 ID"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">상태</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8"
              >
                <option value="all">전체</option>
                <option value="active">활성</option>
                <option value="inactive">비활성</option>
                <option value="suspended">정지</option>
              </select>
            </div>
            <div className="flex items-end">
              <button
                onClick={() => {
                  setSearchTerm('');
                  setStatusFilter('all');
                }}
                className="w-full border border-gray-300 text-gray-700 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-refresh-line mr-1"></i>
                초기화
              </button>
            </div>
          </div>
        </div>

        {/* 일괄 작업 */}
        {selectedStudents.length > 0 && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between">
              <span className="text-blue-800 font-medium">
                {selectedStudents.length}명의 학습자가 선택되었습니다
              </span>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleBulkAction('activate')}
                  className="bg-green-600 text-white px-3 py-1.5 text-sm rounded hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-check-line mr-1"></i>
                  활성화
                </button>
                <button
                  onClick={() => handleBulkAction('suspend')}
                  className="bg-orange-600 text-white px-3 py-1.5 text-sm rounded hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-pause-circle-line mr-1"></i>
                  일시정지
                </button>
                <button
                  onClick={() => handleBulkAction('delete')}
                  className="bg-red-600 text-white px-3 py-1.5 text-sm rounded hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-delete-bin-line mr-1"></i>
                  삭제
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 학습자 테이블 */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">
                    <input
                      type="checkbox"
                      checked={selectedStudents.length === filteredStudents.length && filteredStudents.length > 0}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">학습자 ID</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">이름</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">이메일</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">연락처</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">증명서</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">상태</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">최근 활동</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">액션</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((student) => (
                  <tr key={student.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-4 px-4">
                      <input
                        type="checkbox"
                        checked={selectedStudents.includes(student.id)}
                        onChange={(e) => handleSelectStudent(student.id, e.target.checked)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                    </td>
                    <td className="py-4 px-4 font-mono text-sm text-blue-600">{student.id}</td>
                    <td className="py-4 px-4 font-medium text-gray-900">{student.name}</td>
                    <td className="py-4 px-4 text-gray-700">{student.email}</td>
                    <td className="py-4 px-4 text-gray-600">{student.phone}</td>
                    <td className="py-4 px-4 text-center">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        {student.certificateCount}개
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(student.status)}`}>
                        {getStatusText(student.status)}
                      </span>
                    </td>
                    <td className="py-4 px-4 text-gray-600 text-sm">{student.lastActivity}</td>
                    <td className="py-4 px-4">
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleViewDetail(student)}
                          className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                        >
                          <i className="ri-eye-line"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-600 transition-colors cursor-pointer">
                          <i className="ri-edit-line"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-600 transition-colors cursor-pointer">
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredStudents.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-user-line text-4xl text-gray-300 mb-4"></i>
              <p className="text-gray-500">조건에 맞는 학습자가 없습니다.</p>
            </div>
          )}
        </div>

        {/* 학습자 상세 정보 모달 */}
        {showDetailModal && selectedStudent && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">학습자 상세 정보</h2>
                    <p className="text-gray-600">학습자 ID: {selectedStudent.id}</p>
                  </div>
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">기본 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">이름:</span>
                        <span className="font-medium">{selectedStudent.name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">이메일:</span>
                        <span className="font-medium">{selectedStudent.email}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">연락처:</span>
                        <span className="font-medium">{selectedStudent.phone}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">가입일:</span>
                        <span className="font-medium">{selectedStudent.registeredAt}</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">활동 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">보유 증명서:</span>
                        <span className="font-medium">{selectedStudent.certificateCount}개</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">최근 활동:</span>
                        <span className="font-medium">{selectedStudent.lastActivity}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">상태:</span>
                        <span className={`font-medium px-2 py-1 rounded text-xs ${getStatusColor(selectedStudent.status)}`}>
                          {getStatusText(selectedStudent.status)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex space-x-3 mt-6 pt-6 border-t border-gray-200">
                  <button className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-mail-line mr-2"></i>
                    이메일 발송
                  </button>
                  <button className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-edit-line mr-2"></i>
                    정보 수정
                  </button>
                  <button className="flex-1 border border-red-300 text-red-600 py-2 px-4 rounded-lg hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-user-forbid-line mr-2"></i>
                    계정 정지
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 학습자 추가 모달 */}
        {showAddModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">새 학습자 추가</h2>
                  <button
                    onClick={() => setShowAddModal(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      이름 *
                    </label>
                    <input
                      type="text"
                      value={newStudent.name}
                      onChange={(e) => setNewStudent({ ...newStudent, name: e.target.value })}
                      placeholder="학습자 이름을 입력하세요"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      이메일 *
                    </label>
                    <input
                      type="email"
                      value={newStudent.email}
                      onChange={(e) => setNewStudent({ ...newStudent, email: e.target.value })}
                      placeholder="이메일 주소를 입력하세요"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      연락처
                    </label>
                    <input
                      type="tel"
                      value={newStudent.phone}
                      onChange={(e) => setNewStudent({ ...newStudent, phone: e.target.value })}
                      placeholder="연락처를 입력하세요"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div className="flex space-x-3 mt-6">
                  <button
                    onClick={() => setShowAddModal(false)}
                    className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    취소
                  </button>
                  <button
                    onClick={handleAddStudent}
                    className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-user-add-line mr-2"></i>
                    추가
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
